import { ref, computed } from 'vue'
import { trackEvent } from '~/composables/analytics'
import { response } from '~/assets/js/colorData.js'

// Palette view state: which extraction tab is active, plus the live color
// counts shown on the tabs. Kept separate from selection/generation so the
// tabs can be reused independently.
export function usePaletteView() {
  const tabs = ref([
    { name: 'Visual Palette Extraction', subName: "Colors are extracted from the site's visual layout taking a JPG snapshot.", href: '#', current: true },
    { name: 'Code Palette Extraction', subName: "Colors are extracted from the site's HTML, CSS, and JS files.", href: '#', current: false },
  ])

  const changePaletteView = (givenTab: any) => {
    try {
      trackEvent('Change Palette View (' + givenTab.target.value + ')')
    } catch {}
    if (givenTab.target === undefined) {
      tabs.value.forEach((tab) => {
        tab.current = tab === givenTab
        if (tab === givenTab) {
          try {
            trackEvent('Change Palette View (' + tab.name + ')')
          } catch {}
        }
      })
    } else {
      tabs.value.forEach((tab) => {
        tab.current = tab.name === givenTab.target.value
        if (tab.name === givenTab.target.value) {
          try {
            trackEvent('Change Palette View (' + tab.name + ')')
          } catch {}
        }
      })
    }
  }

  // Force the Visual tab active (used after sampling a custom color).
  const selectVisualTab = () => {
    tabs.value.forEach((tab) => {
      tab.current = tab.name === 'Visual Palette Extraction'
    })
  }

  const totalVisualPaletteColors = computed(() => {
    if (!response.visualPalette || typeof response.visualPalette !== 'object') {
      return 0
    }
    return Object.values(response.visualPalette).reduce((acc, colors) => {
      if (Array.isArray(colors)) {
        return acc + colors.length
      }
      return acc
    }, 0)
  })

  const totalCodePaletteColors = computed(() => {
    if (!response.nearestColors) {
      return 0
    }
    return Object.values(response.nearestColors).reduce((acc, colors) => acc + colors.length, 0)
  })

  return { tabs, changePaletteView, selectVisualTab, totalVisualPaletteColors, totalCodePaletteColors }
}
